import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="relative inline-flex items-center">
      <Globe className="w-4 h-4 text-[#334155]/60 mr-1" />
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value as 'en' | 'my')}
        className="appearance-none bg-transparent text-sm text-[#334155]/70 hover:text-[#334155] cursor-pointer focus:outline-none pr-4"
      >
        <option value="en">EN</option>
        <option value="my">မြန်မာ</option>
      </select>
      <svg className="w-3 h-3 absolute right-0 pointer-events-none text-[#334155]/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  );
};

export default LanguageSelector;
